
import { indicatorData } from "data/indicatorData";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "styles/genericPage.css";

export default function Housing () {

  const [housingData, setHousingData] = useState({});
  const { indicator } = useParams();



  useEffect(() => {
      indicator === undefined 
      ? setHousingData(indicatorData[0].content[2]) 
      : setHousingData(...indicatorData[0].content.filter(i => i.statsURL.indexOf(indicator) > -1));
    
  }, [indicator]);

  return (
    <>
      {housingData ? 
        <div className="flex" key={housingData.statsID}>
          <div className="chart-container">
            <div className="header">
              <h2 className="m-0 big-font">{housingData.title}</h2>
            </div>
            <div className="gap-class">
              {housingData.chart}
            </div>
          </div>
          <div className="notes-container">
            <div className="value-box gap-class">
              <h3 className="big-font">{housingData.statsValue + " " + housingData.statsUnit}</h3>
              <h4>{housingData.statsCaption}</h4>
            </div>
          </div>
        </div>
      : null}
    </>
  );
}
